import { Col, Container, Row } from "react-bootstrap";

import About from "../About/About";
import Contact from "../Contact/Contact";
import Education from "../Education/Education";
import Myskills from "../Skills/skills";
import Projects from "../Projects/Projects";
import React from "react";
import ScrollToTop from "../ScrollToTop";
import SocialMedia from "../SocialMedia";
import TypeWriter from "./TypeWriter";
import myImg from "../../Assets/pic1.png";

function Home() {
  return (
    <section>
      <Container id="home" fluid className="home-section" id="home">
        <Container className="home-content">
          <Row>
            <Col md={6} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> Juber Shaikh</strong>
              </h1>

              <p className="heading-description blockquote">
                A highly motivated, well-qualified individual with experience in
                programming language and developmental tools. I am looking for a
                position in an organization where I can utilize my skills to
                benefit the company while also keeping room to evolve my
                abilities.
              </p>

              <div className="heading-type">
                <TypeWriter />
              </div>
            </Col>

            <Col md={5}>
              <img src={myImg} className="profile-pic" alt="avatar" />
            </Col>
          </Row>
        </Container>
      </Container>
      <Container fluid className="home-about-section">
        <Container>
          <Row>
            <Col md={12} className="home-about-social">
              <h1>Get in Touch</h1>
              <p>
                {" "}
                Whether you want to get in touch, or talk about a project
                collaboration.
                <br />
                <strong>Feel free to connect with me</strong>
              </p>
              <SocialMedia />
            </Col>
          </Row>
        </Container>
      </Container>
      <About />
      <Myskills />
      <Education />
      <Projects />
      <Contact />
    </section>
  );
}

export default Home;
